import TextArea from 'atoms/TextArea';
import Image from 'molecules/Image';
import PopOver from 'molecules/PopOver';
import { useRouter } from'hooks/navigation-router-with-loading'
import { useState } from 'react';
import Icon from 'atoms/Icon';
import Text from 'atoms/Text';
import Tooltip from 'atoms/Tooltip';

function AvailableAndSchedule({
    onNoteSend = () => false,
    className = ''
}) {

    const [showPopOver, setShowPopOver] = useState(false);
    const [noteValue, setNoteValue] = useState('');

    const footerButtons = [
        {
            label: 'Clear',
            kind: 'silent',
            size: 'm',
            onClick: () => setNoteValue('')
        },
        {
            label: 'Send',
            kind: 'primaryLoud',
            size: 'm',
            isDisabled: noteValue === '' ? true : noteValue.length > 255,
            onClick: () => {
                onNoteSend(noteValue);
                setNoteValue('')
                setShowPopOver(false);
            }
        }
    ];

    return (
        <div className={`flex items-center flex-wrap ${className}`}>
            <PopOver
                targetLabel="Ad-hoc availability"
                footerButtons={footerButtons}
                className='lg:flex-1'
                showPopOver={showPopOver}
                setShowPopOver={setShowPopOver}
                customTarget={
                    <div className='text-white lg:bg-green-900 flex items-center h-10 px-2.5 text-sm cursor-pointer hover:bg-[#292929] lg:hover:bg-green-1100'>
                        <span className='hidden lg:block'>Ad-hoc availability</span>
                        <div className='block lg:hidden'>
                            <Image src='/assets/icons/available.svg'
                                width={16}
                                height={16}
                                alt='available icon'
                            />
                        </div>                       
                    </div>
                }
            >
                <TextArea
                    value={noteValue}
                    onValueChange={(val) => setNoteValue(val)}
                    placeholder='For eg. Available dates; hours per day; skillset, training and certification'
                    className='no-border-textarea'
                />
            </PopOver>
           
            <Tooltip text={<Text>The Ad-hoc option is for individuals currently staffed on a project and have some time to spare in between. Sharing your Ad-hoc availability sends a notification to the leads in your L3 and can help you network better and learn on the job. <span className='block mt-2'>You can mention the hours you’re available for and the days when you have bandwidth.</span></Text>} position='bottomRight' width='w-64'>  
                <div  className='text-white lg:bg-green-900 flex items-center h-10 pr-2.5 text-sm cursor-pointer'>
                    <Icon 
                        icon='info__l__stroke'
                        size='w-4 h-4'
                        color="black"
                        className='bg-gray-200 rounded-full cursor-pointer'
                    /> 
                </div>
            </Tooltip>
        </div>
    )
}

export default AvailableAndSchedule;